// extracted by mini-css-extract-plugin
export default {"info_box":"index_info_box_yMVib clearfix","comment":"index_comment_3jZyg","pic":"index_pic_t6-Xn","v_logo":"index_v_logo_Z-Z0o","text":"index_text_iUgDD","time":"index_time_yyvEU"};